import { type FC } from 'react'

import { UnitLabel } from '@/components/elements'
import { LABELS, UNITS } from '@/constants/common/message.constants'
import { useWeightDisplayFormat } from '@/features/dcs/hooks'

/**
 * 重量列の見出し。createShipmentOrdersTableColumns はフックを呼べない素の関数のため、
 * 選択中拠点の単位設定に応じた見出し（重量(t)/重量(kg)）を出す部分だけ
 * コンポーネントに切り出し、AntD Table の title（ReactNode 可）として渡す（Issue #4905）。
 */
export const WeightColumnTitle: FC = () => {
  const { unit } = useWeightDisplayFormat()
  return (
    <>
      {LABELS.WEIGHT}
      <UnitLabel>({UNITS.MASS[unit]})</UnitLabel>
    </>
  )
}
